import { humanFileSize } from './humanFileSize.mjs';

const checkMaxFileSize = ({ file, getFileSizeErrorText, maxFileSize, }) => {
    if (maxFileSize === undefined)
        return '';
    if (file.size > maxFileSize) {
        return getFileSizeErrorText(humanFileSize(maxFileSize, true));
    }
    return '';
};

export { checkMaxFileSize };
